import { render, staticRenderFns } from "./reviewDemand.vue?vue&type=template&id=197e9499&"
import script from "./reviewDemand.vue?vue&type=script&lang=js&"
export * from "./reviewDemand.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports